import DownIcon from 'src/icons/down';

const BTN_CLASSNAMES = 'flex items-center justify-center rounded-full w-10 h-10 mx-2 ';
const NO_GRADIENT_BTN_CLASSNAMES = 'border border-gray-dark';
const GRADIENT_BTN_CLASSNAMES = 'bg-gradient-to-r from-orange to-pink';

const RoundPaginationButtons = ({ currentPage, pages, onPrevClick, onNextClick }) => (
    <div className="w-full flex items-center justify-center mt-6">
        <button
            className={BTN_CLASSNAMES + (currentPage === 1 ? NO_GRADIENT_BTN_CLASSNAMES : GRADIENT_BTN_CLASSNAMES)}
            onClick={onPrevClick}
        >
            <DownIcon
                color={currentPage === 1 ? '#101010' : '#ffffff'}
                alt="previous page"
                className="rotate-90 mr-0.5"
            />
        </button>
        <span>
            {currentPage} / {pages}
        </span>
        <button
            className={BTN_CLASSNAMES + (currentPage === pages ? NO_GRADIENT_BTN_CLASSNAMES : GRADIENT_BTN_CLASSNAMES)}
            onClick={onNextClick}
        >
            <DownIcon
                color={currentPage === pages ? '#101010' : '#ffffff'}
                alt="next page"
                className="next-page-btn ml-0.5"
            />
        </button>
    </div>
);

export default RoundPaginationButtons;
